export class GeneralConstants {
  /**
   * Endpoint QRController
   */
  public static readonly getQR: string = 'qr/get';
  public static readonly getQRemvco = 'qr/getEMVCOcobro';

  /**
   * Endpoint PaymentController
   */
  public static readonly createPendingPayment: string = 'payment/create';
  public static readonly paymentReport: string = 'payment/setPay';
  public static readonly getMovements: string = 'payment/movements/filter';
  public static readonly paymentDetail: string = 'payment/movements/commissions';
  public static readonly movementDetail: string = 'payment/movements/details';
  public static readonly updatePayment: string = 'payment/update';
  public static readonly cancelPayment: string = 'payment/cancelPayment';
  public static readonly anularPago: string = 'payment/anularPago';
  public static readonly getPartialPaymentMovements: string = 'payment/getUserMovementWeb/partials';
  public static readonly getSucursalPaymentMovements: string = 'payment/getUserMovementSucursal';
  public static readonly createPaymentOrder: string = 'payment/create-order';
  public static readonly exportMovementsToExcel: string = 'nova/comercios/generar-movimientos/excel';
  public static readonly refundPayment: string = 'payment/refund';
  public static readonly paymentInfo: string = 'payment/refunds';
  public static readonly getResumenOperaciones: string = 'payment/getResumenOperaciones';

  /**
   * Endpoint PaymentMethodController
   */
  public static readonly createPaymentMethod: string = 'paymentMethod/create';
  public static readonly getPaymentMethod: string = 'paymentMethod/get';
  public static readonly deletePaymentMethod: string = 'paymentMethod/delete';
  public static readonly listPaymentMethod: string = 'paymentMethod/list';

  /**
   * Endpoint PaymentOrderController
   */
  public static readonly getPaymentOrder: string = 'public/payment-order/get';

  /**
   * EndPoint UserController
   */
  public static readonly sendMessage: string = 'user/sendUserMessage';
  public static readonly saveUserProfile: string = 'user/editProfile';
  public static readonly saveOrganismsProfile: string = 'web/organisms/';
  public static readonly updateOrganismsProfile: string = 'web/organisms/update';
  public static readonly getAccountState: string = 'user/account-state';
  public static readonly cashOut: string = 'user/cuenta/cashOut';
  public static readonly cashIn: string = 'cuenta/get-account-info';
  public static readonly activateAccount: string = 'user/activateAccount';
  public static readonly sendSMSRoute: string = 'user/sendSMS';
  public static readonly skipSMSVerificationRoute: string = 'user/skipSMSVerification';
  public static readonly registerRoute: string = 'user/registrationWithCaptcha';
  public static readonly activateDevice: string = 'user/activarDispositivo';
  public static readonly sendActivationMailRoute: string = 'user/register/sendActivationMail';
  public static readonly cancelRegisterRoute: string = 'user/register/cancel';
  public static readonly registerOrganismsRoute: string = 'web/organisms/organismsRegisterWithCaptcha';
  public static readonly userVirtualAccount: string = 'user/cuenta/cash';
  public static readonly uploadProfilePicture: string = 'user/profilePicture/upload';
  public static readonly getProfilePicture: string = 'user/getProfilePicture';
  public static readonly virtualAccountBalance: string = 'user/virtual-account-balance';
  public static readonly deleteAccount: string = 'user/deleteAccount';
  public static readonly rapipagoTxId: string = 'user/cuenta/rapipago/transaccionId';
  public static readonly activateAccountResponsible: string = 'user/activateAccountResponsible';
  public static readonly registerPushId: string = 'user/registerPushId';
  public static readonly getHolderTransfer: string = 'payment/holder';
  public static readonly rapipagoCashOut: string = 'cuenta/rapipago/saldo/cashin';

  /**
   * Endpoint PasswordController
   */
  public static readonly userPasswordReset: string = 'user/resetPassword';
  public static readonly passwordConfirmation: string = 'user/passwordConfirmation';
  public static readonly resetDevice: string = 'user/resetDevice';
  public static readonly updatePassword: string = 'user/updatePassword';
  public static readonly removeDevice: string = 'user/removeDevice';
  public static readonly validarPassword: string = 'user/validarPassword';

  /**
   * Endpoint tarifario
   */
  public static readonly tarifarioSubscribe: string = 'tarifario/subscribir';
  public static readonly tarifarioStatus: string = 'tarifario/status';
  public static readonly tarifarioPlanes: string = 'tarifario/planes';
  public static readonly tarifarioSubscripciones: string = 'tarifario/subscripciones';

  /**
   * EndPoint Ripsa
   */
  public static readonly getServicio: string = 'ripsa/devolverServicio';
  public static readonly ingresoPagoRipsa: string = 'ripsa/ingresoPago';
  public static readonly queryPayment: string = 'ripsa/consultarPago';

  public static readonly getQREMVco: string = 'qr/get-user-emvco';
  public static readonly getQREMVcoSucursal: string = 'qr/get-sucursal-emvco';

  public static readonly getTransaccionId: string = 'user/cuenta/rapipago/transaccionId';

  /**
   * EndPoint OrganismController
   */
  public static readonly validateCuit: string = 'web/organisms/get-persona';
  public static readonly branchOfficesRoute: string = 'web/organisms/sucursales';
  public static readonly branchOffices: string = 'web/organisms/sucursal';
  public static readonly branchOfficesAddRoute: string = 'web/organisms/addSucursal';
  public static readonly branchOfficesUpdateRoute: string = 'web/organisms/editSucursal';

  /**
   * EndPoint Organismo
   */
  // public static readonly getUserResponsibleRoute: string = 'web/organisms/userResponsible';
  // public static readonly addUserResponsibleRoute: string = 'web/organisms/addResponsible';
  // public static readonly editUserResponsibleRoute: string = 'web/organisms/responsable';
  // public static readonly removeUserResponsibleRoute: string = 'web/organisms/responsable';
  public static readonly getUserResponsibleRoute: string = 'web/organisms/getUserResponsibles';
  public static readonly addUserResponsibleRoute: string = 'web/organisms/addResponsible';
  public static readonly editUserResponsibleRoute: string = 'web/organisms/editResponsible';
  public static readonly removeUserResponsibleRoute: string = 'web/organisms/removeResponsible';

  public static readonly cashiersRoute: string = 'web/organisms/puestosCobro';
  public static readonly cashierAddRoute: string = 'web/organisms/sucursal/';
  public static readonly cashierEditRoute: string = 'web/organisms/sucursal/';

  // public static readonly getCommerceRoute: string = 'web/organisms';
  // public static readonly getTokenRoute: string = 'web/organisms/organismo/token';
  // public static readonly getActivities: string = 'web/organisms/organismo/activities';
  public static readonly getCommerceRoute: string = 'web/organisms/get-organism';
  public static readonly getTokenRoute: string = 'web/organisms/get-token';
  public static readonly getActivities: string = 'web/organisms/activities/get-all';

  public static readonly getInfoSucursal: string = 'web/organisms/sucursal/';
  public static readonly getInfoResponsible: string = 'web/organisms/responsable/';
  public static readonly getInfoPuestoCobro: string = 'web/organisms/sucursal/';

  /**
   * PaymentsTypesController
   */
  public static readonly paymentMethodListRoute: string = 'web/paymenttypes/list';
  public static readonly generatePaymentQr: string = 'qr/get-sucursal-emvco';

  /**
   * RecipientController
   */
  public static readonly saveRecipientRoute: string = 'web/destinatarios/save';
  public static readonly deleteRecipientRoute: string = 'web/destinatarios/delete';
  public static readonly getRecipientRoute: string = 'web/destinatarios/all';

  /**
   * Send Help
   */
  public static readonly getReasons: string = 'nova/formConsulta/motivos';
  public static readonly getQueries: string = 'nova/formConsulta/consultas';
  public static readonly sendQuery: string = 'nova/formConsulta';

  /**
   * Montos de comision
   */

  public static readonly getCashin: string = 'tarifario/rapipago/cashin';
  public static readonly getCashout: string = 'tarifario/rapipago/cashout';

  /**
   * Mi Perfil
   */

  public static readonly getPersonaInfo: string = 'cuenta/get-persona-info';
  public static readonly updatePersonaInfo: string = 'cuenta/update-persona-info';

  /**
   * PIX
   */
  public static readonly postPixPreparePay: string = 'pix/prepare-pay/';
  public static readonly postPixSellCancel: string = 'pix/sell-cancel';
  public static readonly getPixStatus: string = 'pix/check-pay-status/';
  public static readonly getPixExchangeRate: string = 'pix/exchange';
  public static readonly validateDiscountCode: string = 'codigo-descuento-pix/validate';

  /**
   * Print ticket info
   */
  public static readonly getTktInfo: string = 'payment/data-detail-movement/';

  /**
   * Doble Factor
   */
  public static readonly sendTwoFactorCode: string = 'security/sendCode';

  /**
   * schedule
   */
  public static readonly getCalendarMovements: string = 'payment/getCalendarMovements';

  /**
   * schedule
   */
  public static readonly downloadLiquidacionPdf: string = 'nova/comercios/generar-liquidacion/pdf';

  /**
   * system
   */
  public static readonly healthCheck: string = 'health';
}
